// extracted by mini-css-extract-plugin
export var bgColor = "why-us-module--bgColor--bGzYG";
export var font_xs = "why-us-module--font_xs--GlbpU";
export var mainDiv = "why-us-module--mainDiv--K0KvG";
export var usWidth = "why-us-module--usWidth--sdw0M";
export var usWidth2 = "why-us-module--usWidth2--xbXQ0";